export const UPDATE_DENOMINATION_COUNT = "UPDATE_DENOMINATION_COUNT";
export const RESET_DENOMINATIONS = "RESET_DENOMINATIONS";

export const updateDenominationCount = (index, count) => ({
  type: UPDATE_DENOMINATION_COUNT,
  payload: { index, count },
});

export const resetDenominations = () => ({
  type: RESET_DENOMINATIONS,
});
